import React, { useCallback } from 'react';

import { Input } from 'antd';

import { getIn } from 'formik';
import type { FieldProps } from 'formik';
import { Hint } from 'v2/components/Shared/Hint';

interface IProps extends FieldProps {
  placeholder?: string;
  onlyNumbers?: boolean;
  replaceSpaceWithComma?: boolean;
  label?: string;
}

export const MultipleTextFormField = ({ field, label, form, replaceSpaceWithComma = true, ...props }: IProps) => {
  const { value, name } = field;

  const errorText = getIn(form.errors, field.name);

  const convertOnlyNumbers = (v: string) => {
    return v.replace(/[^0-9,]/g, '');
  };

  const convertNoSpace = (v: string) => {
    return v.replace(/\s/g, ',');
  };

  const convert = useCallback(
    (v: string) => {
      if (replaceSpaceWithComma) {
        v = convertNoSpace(v);
      }

      if (props.onlyNumbers) {
        v = convertOnlyNumbers(v);
      }

      return v ? v.split(',') : [];
    },
    [props.onlyNumbers, replaceSpaceWithComma]
  );

  const onChangeHandler = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const v = e.target.value;
      const value = convert(v);
      form.setFieldValue(field.name, value);
    },
    [convert, form, field.name]
  );

  const onBlurHandler = useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      const v = e.target.value;
      const value = convert(v);
      form.setFieldValue(field.name, value);
    },
    [convert, form, field.name]
  );

  return (
    <Hint inputName={field.name}>
      <div className='w-full'>
        {label && <label className='mb-1 block text-sm text-gray-600'>{label}</label>}
        <Input
          placeholder={props.placeholder || 'Separe os valores usando , (vírgula)'}
          status={errorText ? 'error' : undefined}
          name={name}
          value={value}
          onChange={onChangeHandler}
          onBlur={onBlurHandler}
        />
        {errorText && <p className='mt-1 text-xs text-red-500'>{errorText}</p>}
      </div>
    </Hint>
  );
};
